/** Název aplikace — sdílený mezi API a webem. */
export const APP_NAME = 'Helfr';
/**
 * VŠECHNY částky v systému jsou BEZ DPH (invariant 3; finance-vcp §8 — přenesená
 * daňová povinnost § 92e u stavebních prací mezi plátci). Peníze nikdy jako float.
 */
export const CASTKY_BEZ_DPH = true;
/**
 * VÝCHOZÍ šablona tranší pozastávky — model pilotní firmy 10 % = 5/2/2/1
 * (5 % po předání, 2 % po 24, 2 % po 48, 1 % po 60 měsících).
 * POZOR (§0b univerzálnost + KG §3 Pozastávka): je to jen výchozí šablona,
 * tranše jsou konfigurovatelné per smlouva — nikdy hardcode.
 */
export const VYCHOZI_TRANSE_POZASTAVKY = [
    { procento: 5, spoustec: 'predani_dila', odkladMesicu: 0 },
    { procento: 2, spoustec: 'predani_dila', odkladMesicu: 24 },
    { procento: 2, spoustec: 'predani_dila', odkladMesicu: 48 },
    { procento: 1, spoustec: 'predani_dila', odkladMesicu: 60 },
];
/** Obvyklá záruční doba ve stavebnictví (měsíce) — default, per smlouva konfigurovatelné. */
export const VYCHOZI_ZARUKA_MESICU = 60;
/**
 * Limity změn závazku u veřejných zakázek dle § 222 ZZVZ (finance-vcp §7).
 * Před implementací hlídače OVĚŘIT proti aktuálnímu znění zákona.
 */
export const ZZVZ_LIMITY = {
    /** De minimis u stavebních prací (§ 222 odst. 4). */
    deMinimisProcent: 15,
    /** Nepředvídané/dodatečné práce per změna (odst. 5, 6). */
    perZmenaProcent: 50,
    /** Kumulativní limit pro změny dle odst. 5 + 6 (odst. 9). */
    kumulativneProcent: 30,
};
//# sourceMappingURL=constants.js.map